<template lang='pug'>
  button.sidebar-minimizer(type='button', @click='sidebarMinimize();brandMinimize()')
</template>
<script>

export default {
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize () {
      document.body.classList.toggle('sidebar-minimized')
    },
    brandMinimize () {
      document.body.classList.toggle('brand-minimized')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sidebar/SidebarMinimizer.vue